/**
 * Application version utility
 *
 * This provides the current build ID/version of the application.
 * It's used to:
 * 1. Display version info in the UI (if needed)
 * 2. Act as a cache-buster for API requests to ensure fresh data
 * 3. Log deployment versions for debugging
 */

// This will be populated at build time if available, or fallback to timestamp
export function getAppVersion(): string {
  // 1. Prefer explicit Public Env Var (set in next.config.mjs or .env)
  if (process.env.NEXT_PUBLIC_APP_VERSION) {
    return process.env.NEXT_PUBLIC_APP_VERSION;
  }

  // 2. Fallback to private BUILD_ID (Server-side only)
  if (typeof window === "undefined" && process.env.BUILD_ID) {
    return process.env.BUILD_ID;
  }

  // 3. Development Fallback
  // If we are here, we are likely in local dev (pnpm dev) where no unique BUILD_ID exists.
  // We return a static string so client/server match in dev mode.
  // Note: In 'pnpm start' (production), BUILD_ID *should* be generated by Next.js,
  // but Next.js internal IDs aren't auto-exposed to env unless we did it in next.config.mjs.
  // Our next.config.mjs fix ensures (1) covers the production case.
  return "dev-mode";
}
